import { defineMessages } from 'react-intl';

const messages = defineMessages({
  welcome_msg_1: {
    id: '7a0MnJ',
    defaultMessage: 'Discover IBM API Connect’s value to your business',
  },
  triggertext_PED: {
    id: 'Tg+nXk',
    defaultMessage:
      '% of time spent per employee doing API development/management',
  },
  triggertext_percentaje_devTime: {
    id: 'buyHr1',
    defaultMessage: 'Percentage time spent per emp. doing API',
  },
  footnote_one: {
    id: 'AKIxVv',
    defaultMessage:
      'The result shown are based on certain assumptions, including 40% time savings in API development/management by using API Connect. The results of this tool are provided for illustrative purposes only, to help you determine whether to consider API Connect as a business solution. The results are not based on actual data or statistical modeling, and may not be accurate or applicable to you. Actual results will vary based on your particular business conditions, usage and configurations and environment, among other factors. Results from the calculator should not be relied upon, and are not a guarantee or commitment regarding any potential or actual financial results or other benefits you may achieve. Actual benefit will vay depending on individual client configurations and conditions.',
  },
  tooltip_PED: {
    id: 'a/H9lI',
    defaultMessage:
      'This includes all activities including API design, development, testing, documentation, security configuration, deployment across multiple environments, internal and/or external socialization & analytics analysis of usage.',
  },
  tile_tittle: {
    id: 'yL4ujB',
    defaultMessage: 'Advanced (customize yearly hours worked and salary)',
  },
  triggertext_NFED: {
    id: 'yHpOdu',
    defaultMessage:
      'Number of full-time employees doing API development/management:',
  },
  'thankyou.details-consent-bp': {
    id: 'oZz635',
    defaultMessage:
      'I consent to IBM providing my business contact information',
  },
  saving_prefix: {
    id: 'hAz8Yo',
    defaultMessage: '$',
  },
  title_savings_1: {
    id: '5CTB1E',
    defaultMessage: 'Potential Yearly Savings',
  },
  hours_saved_year: {
    id: 'gqw64b',
    defaultMessage: 'Estimated Hours saved per year ',
  },
  title_savings_2: {
    id: 'GufXy5',
    defaultMessage: 'Value',
  },
  contactBP: {
    id: 'SWi5iE',
    defaultMessage: 'Business Partner: ',
  },
  invalidTextAvgBurdenCost: {
    id: 'vsz7Qk',
    defaultMessage: 'Please provide a valid number to average burden cost',
  },
  'thankyou.title': {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  triggertext_avg_Burden_Cost: {
    id: 'Z232b2',
    defaultMessage: 'Average Burden Cost of Above Empl in USD',
  },
  tile_head_1: {
    id: 'OttrNL',
    defaultMessage: 'Hours worked per employee per year',
  },
  tile_head_2: {
    id: 'yGw32t',
    defaultMessage: 'Average Annual Salary of Above Employees in USD',
  },
  scoping_text: {
    id: 'CR4c4F',
    defaultMessage:
      'API Connect can help you save time on API management activities, including API development, full lifecycle management, testing, security, and sharing APIs with your communities. This calculator works under the assumption that API Connect is saving your team 40% of the time spent on these activities based on historical analyses.',
  },
  request_a_quote: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  invalidNFED: {
    id: 'Foq73e',
    defaultMessage:
      'Please provide a valid number of Full Employee doing API development/management',
  },
  tooltip_tile_head_1: {
    id: 'lj9t+9',
    defaultMessage:
      'Default value is based on 40 hours per week across 48 weeks per year.',
  },
  triggertext_number_employees: {
    id: 'OjCSnw',
    defaultMessage: 'Number of Employees doing API',
  },
  hours_saving_sufix: {
    id: '4MengK',
    defaultMessage: 'hours',
  },
  'thankyou.details-title': {
    id: 'NWIE97',
    defaultMessage: 'Request details',
  },
  triggertext_hours_worked: {
    id: 'pGctNu',
    defaultMessage: 'Hours worked per emp per year',
  },
  'thankyou.subtitle': {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  'return-to-estimator': {
    id: 'jQ9EVW',
    defaultMessage: 'Return to API connect web page',
  },
  invalidTextPED: {
    id: 'ovo+oL',
    defaultMessage: 'Please provide a valid % time spent developing API',
  },
  tooltip_tile_head_2: {
    id: '/SM8Hv',
    defaultMessage:
      'Based on the 2023 US Average Salary for roles such as API Architect, API Developer, API Integration, API Tester and Infrastructure Operations',
  },
  'drawer-close': {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  yearly_savings: {
    id: 'dvExzi',
    defaultMessage: 'Estimated Dollars saved per year',
  },
  invalidTextHoursWorked: {
    id: '3cq4zD',
    defaultMessage:
      'Please provide a valid number of hours worked per employee per year',
  },
  preferred_bp: {
    id: '9Auwhe',
    defaultMessage: 'Preferred IBM Business Partner',
  },
  footnotes: {
    id: 't1Ql7Y',
    defaultMessage: 'Footnotes',
  },
});

export default messages;
